import { RichText } from "components/RichTextWidget";
import { Container, Heading2, ImageLite } from "shared/components";

import styles from "./Hero014.module.scss";

export const Hero014 = ({ payload }) => {
  const title = payload?.title ?? "";
  const text = payload?.text ?? "";
  const lead = payload?.lead ?? "";
  const image = payload?.image ?? {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <ImageLite image={image} className={styles.image} />
          <div className={styles.content}>
            <Heading2 className={styles.title}>{title}</Heading2>
            <RichText value={lead} className={styles.preview} />
            <RichText
              color="dark"
              value={text}
              className={styles.description}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hero014;
